<template lang="pug">
.parametros-fornecedor
    .parametros-fornecedor__search
        i.el-icon-search
        input.input-search(
            v-model='filtro.nome',
            prefix-icon='el-icon-search',
            type='text',
            :placeholder='$t("configuracaoParametros.listagem.busquePeloNome")',
            autocomplete='off',
            @keyup.enter='buscarConfiguracoes(1)'
        )
    .parametros-fornecedor__titulo
        h3 {{ $t('configuracaoParametros.listagem.tabela.titulo.fornecedor') }}
    .parametros-fornecedor__tabela
        el-table(:key="listagemTableKey('parametros-fornecedor', configuracoes, paginacao.pagina + 1)", :data='configuracoes')
            el-table-column(type='expand')
                template(slot-scope='scope')
                    #expand-table-fornecedor(
                        v-if='scope.row?.excecoes?.length > 0'
                    )
                        .expand-table
                            .expand-table__row(
                                v-for='(excecao, index) in scope.row.excecoes',
                                :key='`expand-table-${scope.row.id}-${index}`'
                            )
                                .expand-table__item.expand-table__first
                                .expand-table__item.expand-table__more
                                    span.expand-table__label {{ $t('configuracaoParametros.listagem.tabela.labels.estado') }}
                                    span.expand-table__value {{ excecao.nome }}
                                .expand-table__item.expand-table__more
                                    span.expand-table__label {{ $t('configuracaoParametros.listagem.tabela.labels.distancia') }}
                                    span.expand-table__value {{ formatNumber(excecao.distanciaRaioKm) }}
                                .expand-table__item.expand-table__more
                                    span.expand-table__label {{ $t('configuracaoParametros.listagem.tabela.labels.percentual') }}
                                    span.expand-table__value {{ formatNumber(excecao.percentualCapacidadeProdutiva) }}
                                .expand-table__item.expand-table__last
                                    span.expand-table__label {{ $t('mensagens.comuns.acoes') }}
                                    .expand-table__value
                                        i.mdi.mdi-eye-outline.expand-table__icon(
                                            style='font-size: 18px',
                                            @click='abrirModalVisualizarExcecoes(excecao.id)'
                                        )

                    .bloco-lista-excecoes(v-else)
                        span {{ $t('configuracaoParametros.listagem.tabela.naoPossuiExcecoes') }}
            el-table-column(
                prop='nome',
                :label='$t("configuracaoParametros.listagem.tabela.labels.nome")'
            )
                template(slot-scope='scope')
                    span.parametros-fornecedor__tag {{ scope.row.nome }}
                        el-tag(
                            v-if='scope.row.excecoes?.length > 0',
                            size='mini'
                        )
                            | + {{ scope.row.excecoes.length }}
            el-table-column(
                prop='distanciaRaioKm',
                :label='$t("configuracaoParametros.listagem.tabela.labels.distancia")'
            )
                template(slot-scope='scope')
                    span {{ formatNumber(scope.row.distanciaRaioKm) }}
            el-table-column(
                prop='percentualCapacidadeProdutiva',
                :label='$t("configuracaoParametros.listagem.tabela.labels.percentual")'
            )
                template(slot-scope='scope')
                    span {{ formatNumber(scope.row.percentualCapacidadeProdutiva) }}%

            el-table-column(
                :label='$t("mensagens.comuns.acoes")',
                width='180',
                align='center'
            )
                .template(slot-scope='scope')
                    el-dropdown.action-button
                        i.mdi.mdi-dots-vertical
                        el-dropdown-menu(slot='dropdown')
                            el-dropdown-item(
                                icon='el-icon-view',
                                @click.native='visualizarConfigParam(scope.row.id)'
                            ) {{ $t('mensagens.comuns.visualizar') }}
                            el-dropdown-item(
                                icon='el-icon-edit',
                                @click.native='editarConfigParam(scope.row.id)'
                            ) {{ $t('mensagens.comuns.editar') }}
                            el-dropdown-item(
                                icon='el-icon-delete',
                                @click.native='confirmarRemocao(scope.row.id)'
                            ) {{ $t('mensagens.comuns.excluir') }}

            template(slot='empty')
                el-empty(
                    :description='$t("configuracaoParametros.listagem.tabela.semDados")'
                )
        .parametros-fornecedor__paginacao
            span.parametros-fornecedor__paginacao-label {{ totalItens() }}
            el-pagination(
                background,
                name='paginacao-parametros-estado',
                :page-size='paginacao.itensPorPagina',
                :current-page.sync='paginacao.pagina + 1',
                layout='prev, pager, next',
                :total='paginacao.total',
                @current-change='mudarPagina'
            )
    ModalVisualizarExcecoes(
        :show='showModalVisualizarExcecoes',
        @close='fecharModalVisualizarExcecoes',
        :idConfiguracaoRastreabilidade='idConfiguracaoRastreabilidade'
    )
</template>

<script>
import services from '@/services/ConfiguracaoRastreabilidadeService';
import formatters from '@/utils/formatters';

export default {
    name: 'ParametrosEstado',
    components: {
        ModalVisualizarExcecoes: () =>
            import(
                '@/views/contratos-originacao/parametros/views/components/ModalVisualizarExcecoes.vue'
            )
    },
    data() {
        return {
            showModalVisualizarExcecoes: false,
            idConfiguracaoRastreabilidade: 0,
            filtro: {
                nome: '',
                tipoConfiguracaoRastreabilidade: 'FORNECEDOR'
            },
            configuracoes: [],
            paginacao: {
                total: 0,
                itensPorPagina: 10,
                pagina: 0
            },
            pageable: {
                page: 0,
                size: 10
            }
        };
    },
    mounted() {
        this.buscarConfiguracoes();
    },
    methods: {
        buscarConfiguracoes() {
            return services
                .buscarConfiguracoesRastreabilidadePorFiltro(
                    this.filtro,
                    this.pageable
                )
                .then(({ data }) => {
                    this.configuracoes = data.configuracoes;
                    this.paginacao = data.paginacao;
                })
                .catch(() => {
                    this.$notify.error(
                        this.$t(
                            'configuracaoParametros.listagem.erroBuscarConfiguracoesRastreabilidade'
                        )
                    );
                });
        },
        confirmarRemocao(id) {
            this.$messageBox
                .confirm(
                    this.$t(
                        'mensagens.operacao.formularioPessoa.confirmaRemoverRegistro'
                    ),
                    this.$t('mensagens.comuns.confirmar'),
                    {
                        confirmButtonText: this.$t('mensagens.comuns.sim'),
                        cancelButtonText: this.$t('mensagens.comuns.cancelar'),
                        type: 'warning'
                    }
                )
                .then(() => {
                    this.removerConfiguracao(id);
                });
        },
        editarConfigParam(id) {
            this.$router.push({
                name: 'ParametrosFornecedorFormulario',
                params: {
                    idConfiguracaoRastreabilidade: id
                }
            });
        },
        removerConfiguracao(id) {
            return services
                .excluirConfiguracaoRastreabilidade(id)
                .then(() => {
                    this.buscarConfiguracoes();
                    this.$notify.success(
                        this.$t(
                            'configuracaoParametros.sucesso.sucessoExcluirDados'
                        )
                    );
                })
                .catch(() => {
                    this.$notify.error(
                        this.$t('configuracaoParametros.erro.erroExcluirDados')
                    );
                });
        },
        goToCadastroConfiguracaoParametros() {
            this.$router.push({
                name: 'CadastroConfiguracaoParametros',
                params: {
                    tipoCadastro: {
                        nome: this.activeTab.toLocaleLowerCase(),
                        codigo: this.activeTab
                    }
                }
            });
        },
        formatNumber(number) {
            return number ? formatters.formatNumber(number, 2) : '-';
        },
        totalItens() {
            const total = this.paginacao.total;
            return total > 1
                ? `${total} ${this.$t(
                      'mensagens.comuns.estados'
                  ).toLocaleLowerCase()}`
                : `${total} ${this.$t(
                      'mensagens.comuns.estado'
                  ).toLocaleLowerCase()}`;
        },
        mudarPagina(pagina) {
            this.pageable.page = pagina - 1;
            this.buscarConfiguracoes();
        },
        abrirModalVisualizarExcecoes(idConfiguracaoRastreabilidade) {
            this.showModalVisualizarExcecoes = true;
            this.idConfiguracaoRastreabilidade = idConfiguracaoRastreabilidade;
        },
        fecharModalVisualizarExcecoes() {
            this.showModalVisualizarExcecoes = false;
            this.idConfiguracaoRastreabilidade = 0;
        },
        visualizarConfigParam(id) {
            this.$router.push({
                name: 'ParametrosFornecedorDetalhes',
                params: {
                    idConfiguracaoRastreabilidade: id
                }
            });
        }
    }
};
</script>

<style lang="scss">
.parametros-fornecedor {
    &__titulo {
        margin-top: 20px;
    }
    &__tabela {
        padding-top: 4px;
        margin-top: 20px;
        background-color: var(--white);
        border-radius: $default-border-radius;
    }
    &__tag {
        display: flex;
        align-items: center;
        gap: 5px;
        .el-tag {
            font-weight: bold;
        }
    }
    &__paginacao {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        padding: 20px;
    }
    &__paginacao-label {
        color: $primary;
        font-weight: bold;
    }
    &__search {
        display: flex;
        background-color: $white;
        padding: 7px 10px;
        border-radius: $default-border-radius;
        gap: 5px;
        align-items: center;
        @include default-box-shadow();
    }
    .expand-table {
        width: 100%;
        &__row {
            display: flex;
            width: 100%;
            & + .expand-table__row {
                border-top: 1px solid #f0f2f7;
            }
        }
        &__label {
            font-weight: bold;
            color: var(--primary);
        }
        &__item {
            padding: 5px 10px;
            display: flex;
            flex-direction: column;
            gap: 10px;
        }
        &__first {
            width: 48px;
            flex: 0 0 48px;
        }
        &__more {
            width: 33.33%;
            flex: 1 1 auto;
        }
        &__last {
            width: 180px;
            flex: 0 0 180px;
            display: flex;
            align-items: center;
            flex-direction: column;
        }
        &__icon {
            cursor: pointer;
        }
    }
    .bloco-lista-excecoes {
        margin-left: 58px;
    }
}
input {
    border: 0 !important;
    outline: 0;
    width: 100%;
}
</style>
